export const exportHeadersCA = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },
    {
        label: "Billto",
        key: "customer_billto_account_number",
    },
    {
        label: "Enrollment / Transfer",
        key: "member_account_created_by",
    },
    {
        label: "Account Created By",
        key: "request_by",
    },
    {
        label: "Status",
        key: "is_active",
    },
    {
        label: "Deactivated",
        key: "account_disabled",
    },
    // {
    //     label: "Start Date",
    //     key: "deactive_date",
    // },
    {
        label: "Deactivation Date",
        key: "admin_deactive_date",
    },
    {
        label: "Set For Deactivation",
        key: "account_disabled"
    },
    {
        label: "DSM/MM Account",
        key: "mktcls_modified"
    },
    {
        label: "Move to Non-Points",
        key: "mktcls_modified1"
    },
    
    
   
]
export const exportHeadersUS = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },
    {
        label: "Billto",
        key: "customer_billto_account_number",
    },
    {
        label: "Enrollment / Transfer",
        key: "member_account_created_by",
    },
    {
        label: "Account Created By",
        key: "request_by",
    },
    {
        label: "Status",
        key: "is_active",
    },
    {
        label: "Deactivated",
        key: "account_disabled",
    },
    // {
    //     label: "Start Date",
    //     key: "deactive_date",
    // },
    {
        label: "Deactivation Date",
        key: "admin_deactive_date",
    },
    {
        label: "Set For Deactivation",
        key: "account_disabled"
    },
    {
        label: "DSM/MM Account",
        key: "mktcls_modified"
    },
    {
        label: "Non-Points",
        key: "mktcls_modified1"
    },
    {
        label: "Consented",
        key: "consent_flag"
    },
    {
        label: "System Managed",
        key: "system_managed"
    },
    {
        label: "Enrollment Date",
        key: "signup_date"
    },
    {
        label: "Consented Date",
        key: "consent_date"
    },
    {
        label: "Dormant Start",
        key: "dormant_paused_date"
    },
    {
        label: "Points Reactivated",
        key: "reactivation_date"
    },
    
    
   
]